export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/visual-cues-icon.svg?1c7fb255cef059f066abd7eaef800c6b";